import useKeyDownHandler from '@/core/hooks/useKeyDownHandler/useKeyDownHandler';

export default useKeyDownHandler;
